<template>
    <div class="sustainability-r">
        <h4>Responsabilità sociale aziendale</h4>
        <p class="indent">L’impegno di Alcomet per il benessere dei propri dipendenti e dell’intera  società, unitamente alle sue diffuse attività caritatevoli ed all’attiva politica ambientale, rappresentano una parte significativa degli sforzi aziendali di responsabilità sociale.</p>
      <p class="indent">Nonostante sia principalmente votata all’export, Alcomet rimane strettamente connessa allo sviluppo dell’economia e della società bulgara. Alcuni degli obiettivi aziendali relativi alla responsabilità sociale riguardano l’aumento del tasso di occupazione della comunità locale, il sostegno efficace ad istituzioni che operano in ambito scolastico, medico, culturale o altro ancora; all’impegno congiunto con organizzazioni caritatevoli.  Mr. Fikret Ince, maggior azionista e presidente dell’organismo di supervisione della società, ha ricevuto la cittadinanza onoraria di Shumen per la sua attività caritatevole e per il contributo allo sviluppo dell’economia cittadina. Nel 2015, per  il secondo anno consecutivo, Alcomet è stata premiata con il premio di Benefattore dell’anno dal comune di Shumen.</p>
        <p><a href="/static/files/Policy_Soc-Resp.pdf" target="_blank">Policy for Social Responsibility</a></p>
        <p><a href="/static/files/A-POLICY-REGARDING-CHILD-LABOUR-1.pdf" target="_blank">Policy regarding child labour</a></p>
        <p><a href="/static/files/suppliers-code-of-conduct-2020.pdf" target="_blank">Suppliers’ Code of Conduct </a></p>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.sustainability-r > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
a {
  text-decoration: underline;
}
@media screen and (max-width: 1000px) {
  .sustainability-r {
    padding-bottom: 20px;
  }
  .sustainability-r > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sustainability/Responsibility.vue